var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.HintTooltip
  }, [_c('SIcon', {
    class: _vm.$style.icon,
    attrs: {
      "icon": "i-info",
      "size": "14"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.openHintModal.apply(null, arguments);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p4",
    class: _vm.$style.hint,
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };